const ForwardIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 28">
            <g id="download" transform="translate(0 28) rotate(-90)">
                <g id="Group_7074" data-name="Group 7074">
                    <path
                        id="Path_3232"
                        data-name="Path 3232"
                        d="M12.635,14.809V2.5a1.888,1.888,0,0,1,1.75-2H15.49a1.888,1.888,0,0,1,1.75,2V14.809a1.888,1.888,0,0,0,1.75,2H21.5a1.025,1.025,0,0,1,.6,1.725L16.143,25a1.6,1.6,0,0,1-2.411,0L7.776,18.534a1.025,1.025,0,0,1,.6-1.725h2.506a1.887,1.887,0,0,0,1.75-2"
                        transform="translate(-0.938)"
                        fill="#fff"
                    />
                    <path
                        id="Path_3233"
                        data-name="Path 3233"
                        d="M.5,30a1.416,1.416,0,0,1,1.313-1.5h24.5a1.513,1.513,0,0,1,0,3H1.813A1.416,1.416,0,0,1,.5,30"
                        transform="translate(-0.063)"
                        fill="#fff"
                    />
                    <path
                        id="Path_3234"
                        data-name="Path 3234"
                        d="M12.635,14.809V2.5a1.888,1.888,0,0,1,1.75-2H15.49a1.888,1.888,0,0,1,1.75,2V14.809a1.888,1.888,0,0,0,1.75,2H21.5a1.025,1.025,0,0,1,.6,1.725L16.143,25a1.6,1.6,0,0,1-2.411,0L7.776,18.534a1.025,1.025,0,0,1,.6-1.725h2.506A1.887,1.887,0,0,0,12.635,14.809Z"
                        transform="translate(-0.938)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_3235"
                        data-name="Path 3235"
                        d="M.5,30a1.416,1.416,0,0,1,1.313-1.5h24.5a1.513,1.513,0,0,1,0,3H1.813A1.416,1.416,0,0,1,.5,30Z"
                        transform="translate(-0.063)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                    <path
                        id="Path_3236"
                        data-name="Path 3236"
                        d="M11,19h8.75l-4.375,4.5Z"
                        transform="translate(-1.375)"
                        fill="#d6d6d6"
                    />
                    <path
                        id="Path_3237"
                        data-name="Path 3237"
                        d="M11,19h8.75l-4.375,4.5Z"
                        transform="translate(-1.375)"
                        fill="none"
                        stroke="#d6d6d6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                    />
                </g>
            </g>
        </svg>
    );
};

export default ForwardIcon;
